module.exports = __webpack_public_path__ + "static/media/video_dica_legal.79442925.jpg";